import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { Pharmacy } from '@enums/pharmacies';
import { UpsellSlugs } from '@enums/upsell-slugs';
import { TreatmentType } from '@models/treatment-types/treatment-type.model';

/**
 * Defines the Metformin treatment type for Stallion.
 */
export const StallionMetforminTreatment = new TreatmentType({
  id: '23',
  name: ConsultationTreatmentTypes.Metformin,
  designatedPharmacyId: Pharmacy.TAHA,
  shippingService: 'USPS First-Class - 3-4 Days (Free)',
  requireHeightAndWeight: true,
  eligibleTreatmentTypes: [{ id: 3949, name: UpsellSlugs.MetforminExtendedRelease }],
});
